<template>
  <v-container class="cookies-style">
    <v-card flat>
      <v-card-text>
        <h2 style="text-align:center; color: #125488; margin-top:30px;">
          นโยบายการใช้คุกกี้ (Cookies Policy)
        </h2>
      </v-card-text>
      <v-divider></v-divider><br />
      <v-card-text>
        <h3>1. คุกกี้คืออะไร</h3>
        <br />
        <ul>
          <dd>
            คุกกี้ คือ
            ไฟล์ข้อความขนาดเล็กที่ถูกดาวน์โหลดไปยังอุปกรณ์คอมพิวเตอร์หรืออุปกรณ์มือถือของท่าน
            ซึ่งทำหน้าที่บันทึกข้อมูลและการตั้งค่าต่าง ๆ เช่น
            บันทึกข้อมูลการตั้งค่าภาษาในอุปกรณ์บนอุปกรณ์ของท่าน
            บันทึกสถานะการเข้าใช้งานในปัจจุบันของท่าน
            เพื่อช่วยให้ท่านสามารถเข้าใช้งานเว็บไซต์และ/หรือแอปพลิเคชัน
            (รวมเรียกว่า “บริการ”) ได้อย่างต่อเนื่อง
            รวมถึงมีการรวบรวมข้อมูลเกี่ยวกับประวัติการเข้าใช้งานบริการที่ท่านชื่นชอบในรูปแบบไฟล์
            โดยคุกกี้ไม่ได้ทำให้เกิดอันตรายต่ออุปกรณ์ของท่าน
            และเนื้อหาในคุกกี้จะถูกเรียกออกมาดูหรืออ่านได้โดยบริการที่สร้างคุกกี้ดังกล่าวเท่านั้น
          </dd>
        </ul>
      </v-card-text>
      <v-card-text>
        <h3>2. ประโยชน์ของคุกกี้</h3>
        <br />
        <ul>
          <dd>
            คุกกี้จะบอกให้ กองทุนส่งเสริมการพัฒนาตลาดทุน (“CMDF”)
            ทราบว่าท่านเข้าใช้งานส่วนใดในบริการของ CMDF เพื่อที่ CMDF
            จะสามารถมอบประสบการณ์การใช้บริการที่ดีขึ้นและตรงกับความต้องการของท่านได้
            นอกจากนี้
            การบันทึกการตั้งค่าแรกของบริการด้วยคุกกี้จะช่วยให้ท่านเข้าถึงบริการด้วยค่าที่ตั้งไว้ทุกครั้งที่ใช้งาน
            ยกเว้นในกรณีที่คุกกี้ถูกลบซึ่งจะทำให้การตั้งค่าทุกอย่างจะกลับไปที่ค่าเริ่มต้น
          </dd>
        </ul>
      </v-card-text>
      <v-card-text>
        <h3>3. การใช้งานคุกกี้</h3>
        <br />
        <ul>
          <dd>
            CMDF ใช้คุกกี้และเทคโนโลยีอื่น เช่น พิกเซลแท็ก (Pixel-tags)
            บนบริการของ CMDF (รวมเรียกว่า
            <b>“บริการที่อ้างอิงนโยบายการใช้คุกกี้”</b>) ดังนั้น
            บริการใดก็ตามที่ท่านใช้เพื่อเข้าถึงบริการที่อ้างอิงนโยบายการใช้คุกกี้จะได้รับคุกกี้จาก
            CMDF
          </dd>
          <br />
          <dd>
            เมื่อท่านเข้าถึงบริการที่อ้างอิงนโยบายการใช้คุกกี้ คุกกี้ของ CMDF
            จะถูกดาวน์โหลดไปยังอุปกรณ์ของท่านเพื่อเก็บข้อมูลเกี่ยวกับรูปแบบการใช้และประวัติการใช้บริการ
            ข้อมูลหรือบริการที่ท่านสนใจ
            รวมถึงหมายเลขอ้างอิงการเข้าใช้บริการล่าสุดของท่าน เป็นต้น
          </dd>
          <br />
          <dd>
            นอกจากนั้น CMDF มีการใช้งานคุกกี้ร่วมกับเทคโนโลยีประเภทพิกเซลแท็ก
            เพื่อทราบถึงรูปแบบการใช้และประวัติการใช้บริการ
            ข้อมูลหรือบริการที่ท่านสนใจ และนำไปวิเคราะห์ เพื่อพัฒนาการให้บริการ
            แสดงเนื้อหา โฆษณา
            หรือประชาสัมพันธ์กิจกรรมที่เหมาะสมรวมถึงการบริการต่าง ๆ
            ที่ตรงกับความสนใจของท่าน
            เพื่อเพิ่มความพึงพอใจให้แก่ท่านได้มากยิ่งขึ้น อย่างไรก็ตาม CMDF
            จะใช้งานคุกกี้ภายใต้รายละเอียดที่ระบุใน
            <a @click="goToPrivacy()"
              >คำประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)</a
            >
          </dd>
          <br />
          <dd>สำหรับประเภทคุกกี้ที่ CMDF ใช้งาน สามารถแบ่งประเภทได้ดังนี้</dd>
          <br />
          <dd>3.1 คุกกี้เพื่อการให้บริการ</dd>
          <br />
          <dd>
            คุกกี้เพื่อการให้บริการจะช่วยให้ท่านสามารถใช้บริการ
            และ/หรือเข้าถึงฟังก์ชันต่าง ๆ ได้ เช่น
            คุกกี้ที่จัดการเรื่องการเข้าสู่ระบบ (Login)
            และสถานะการเข้าสู่ระบบของท่าน
          </dd>
          <br />
          <dd>3.2 คุกกี้ที่ช่วยเสริมประสิทธิภาพในการใช้บริการ</dd>
          <br />
          <dd>
            คุกกี้ที่ช่วยเสริมประสิทธิภาพในการใช้บริการจะช่วยอำนวยความสะดวกแก่ท่านในการใช้บริการ
            รวมทั้งช่วยให้ CMDF รู้จักท่านมากยิ่งขึ้น โดย CMDF
            จะใช้ข้อมูลดังกล่าวนี้ในการนำเสนอและพัฒนาสินค้าและ/หรือบริการของ
            CMDF ให้ตรงกับความสนใจของท่านต่อไป
          </dd>
          <dd>
            ตัวอย่างการอำนวยความสะดวกแก่ท่านในการใช้บริการด้วยคุกกี้ประเภทนี้
            คือ
          </dd>
          <br />
          <ul type="disc">
            <li>ช่วยจำสถานะของการใช้บริการ เช่น ภาษาที่เลือกใช้</li>
            <br />
            <li>
              ช่วยจำคำตอบที่ท่านเคยตอบไปแล้ว
              ซึ่งจะช่วยให้ท่านไม่ต้องตอบคำถามเดิมซ้ำอีก
            </li>
            <br />
            <li>ให้บริการ LiveChat บนเว็บไซต์ของ CMDF</li>
            <br />
            <li>
              ให้บริการฟังก์ชัน Social Media Sharing
              ซึ่งจะช่วยให้ท่านสามารถแบ่งปันเนื้อหาที่สนใจบนเครือข่ายสังคมออนไลน์
              (Social Network)
            </li>
          </ul>
          <br />
          <dd>
            ทั้งนี้
            เพื่อการให้บริการและเพื่ออำนวยความสะดวกแก่ท่านในการใช้บริการตามตัวอย่างข้างต้น
            CMDF มีการใช้งานโปรแกรมเสริม (Plugin) และบริการของบุคคลที่สาม เช่น
            Google Analytics, Facebook Analytics, Truehits, Hotjars, Facebook,
            Line, Twitter และ AddThis
          </dd>
        </ul>
      </v-card-text>
      <v-card-text>
        <h3>4. วิธีปิดการทำงานของคุกกี้</h3>
        <br />
        <ul>
          <dd>
            ท่านสามารถปิดการทำงานของคุกกี้ได้ โดยการตั้งค่าเบราว์เซอร์ของท่าน
            และตั้งค่าความเป็นส่วนตัวเพื่อระงับการรวบรวมข้อมูลโดยคุกกี้ในอนาคต
            (รายละเอียดเพิ่มเติมสามารถศึกษาได้จาก AboutCookies.org )
          </dd>
          <dd>
            อย่างไรก็ตาม บริการบางอย่างบนเว็บไซต์ของ CMDF
            จำเป็นต้องมีการใช้คุกกี้
            หากท่านปิดการทำงานคุกกี้อาจทำให้ท่านใช้งานฟังก์ชันบางอย่างหรือทั้งหมดของบริการดังกล่าวได้อย่างไม่ราบรื่น
          </dd>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  methods: {
    goToPrivacy() {
      // this.$router.push(`/home/PrivacyPolicy`)
      let routeData = this.$router.resolve("/home/PrivacyPolicy");
      window.open(routeData.href);
    }
  }
};
</script>
<style lang="css" scoped="">
/* @import url('https://fonts.googleapis.com/css?family=Kanit&display=swap'); */
.cookies-style {
  font-family: 'Kanit', sans-serif;
}
</style>
